import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_CPD_CATEGORY: (userId) => ({ userId }),
    API: {
      GET_CPD_CATEGORY: apiResourceActionCreator('cpdCategorys')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.CpdCategory), authToken, actions.user.api.getCpdCategory)

const configuration = {
  name: 'getCpdCategory',
  action: actions,
  sagas: undefined,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingCpdCategory: true
    }),
    success: (state, action) => ({
      ...state,
      cpdCategories: action.payload.cpdCategorys,
      isFetchingCpdCategory: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingCpdCategory: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getCpdCategory.js